import cryptoJS from "../cryptoJS";

const prefix = 'hdi';

const localStorageHelper = {

    // Save in localStorage
    save(id: string, data: any): void {
        localStorage.setItem(`${prefix}.${id}`, cryptoJS.encrypt(JSON.stringify(data)));
    },

    // Get from localStorage
    get<T>(id: string): T | null {
        const resp = localStorage.getItem(`${prefix}.${id}`);
        return resp ? JSON.parse(cryptoJS.decrypt(resp)) as T : null;
    },

};

export default localStorageHelper;
  